// extracted by mini-css-extract-plugin
export var scrollArea = "_on-0";